class TC_LoginForm {
    constructor () {
        if ($('.is-special-page #login_form').length) {
            this.initEvents();
        }
    }

    initEvents () {
        this.form = $('.is-special-page #login_form');

        this.UI = {
            popups: {
                login: this.form.parent(),
                password: $('.mod-calmradio-login.password-reminder'),
                username: $('.mod-calmradio-login.username-reminder')
            },
            forms: {
                username: $('.username-reminder-form'),
                password: $('.password-reminder-form'),
            },
            messages: {
                empty: this.form.find('.mod-calmradio-login-message-empty'),
                error: this.form.find('.mod-calmradio-login-message-error'),
                success: this.form.find('.mod-calmradio-login-message-success'),
                submitError: this.form.find('.mod-calmradio-login-message-submit-error'),
                usernameError: $('.mod-calmradio-login-username-reminder-message-error'),
                usernameEmail: $('.mod-calmradio-login-username-reminder-message-email'),
                usernameSuccess: $('.mod-calmradio-login-username-reminder-message-success'),
                passwordError: $('.mod-calmradio-login-password-reminder-message-error'),
                passwordEmail: $('.mod-calmradio-login-password-reminder-message-email'),
                passwordSuccess: $('.mod-calmradio-login-password-reminder-message-success')
            },
            buttons: {
                submit: this.form.find('.mod-calmradio-login-button'),
                submitUsername: $('.mod-calmradio-username-reminder-button'),
                submitPassword: $('.mod-calmradio-password-reminder-button'),
                cancelUsername: $('.mod-calmradio-username-reminder-cancel-button'),
                cancelPassword: $('.mod-calmradio-password-reminder-cancel-button'),
                loginWithFb: $('.mod-calmradio-login-with-fb'),
                loginWithGoogle: $('.mod-calmradio-login-with-google')
            },
            links: {
                passwordReminder: this.form.find('.mod-calmradio-password-reminder-link'),
                usernameReminder: this.form.find('.mod-calmradio-username-reminder-link')
            },
            inputs: {
                username: this.form.find('input[name="username"]'),
                password: this.form.find('input[name="password"]'),
                rememberMe: this.form.find('#remember'),
                return: this.form.find('input[name="return"]'),
                usernameReminder: $('.mod-calmradio-login-username-reminder-email'),
                passwordReminder: $('.mod-calmradio-login-password-reminder-email')
            }
        };

        if (!this.UI.buttons.submit.hasClass('g-recaptcha')) {
            this.UI.buttons.submit.on('click', e => {
                e.preventDefault();
                this.prepareForm();
            });
        }

        this.UI.buttons.submitUsername.on('click', e => {
            e.preventDefault();
        });

        this.UI.buttons.submitPassword.on('click', e => {
            e.preventDefault();
        });

        this.UI.buttons.cancelUsername.on('click', e => {
            e.preventDefault();
            this.UI.popups.username.addClass('is-hidden');
            this.UI.popups.login.removeClass('is-hidden');
        });

        this.UI.buttons.cancelPassword.on('click', e => {
            e.preventDefault();
            this.UI.popups.password.addClass('is-hidden');
            this.UI.popups.login.removeClass('is-hidden');
        });

        this.UI.inputs.username.on('keyup', e => {
            this.UI.inputs.username.removeClass('is-invalid');
            this.checkIfAllIsFilled();
        });

        this.UI.inputs.password.on('keyup', e => {
            this.UI.inputs.password.removeClass('is-invalid');
            this.checkIfAllIsFilled();
        });

        this.UI.links.passwordReminder.on('click', e => {
            e.preventDefault();
            this.UI.popups.login.addClass('is-hidden');
            this.UI.popups.password.removeClass('is-hidden');
        });

        this.UI.links.usernameReminder.on('click', e => {
            e.preventDefault();
            this.UI.popups.login.addClass('is-hidden');
            this.UI.popups.username.removeClass('is-hidden');
        });

        this.UI.buttons.loginWithFb.on('click', e => {
            e.preventDefault();
            jfbc.login.provider('facebook');
        });

        this.UI.buttons.loginWithGoogle.on('click', e => {
            e.preventDefault();
            jfbc.login.provider('google');
        });

        this.UI.popups.login.on('click', e => {
            if (e.target.tagName === 'SPAN' && e.target.getAttribute('data-action') === 'resend_email') {
                this.resendEmail();
            }
        });
    }

    prepareForm () {
        if (this.isEmptyForm()) {
            this.resetCaptcha();
            return;
        }

        this.submitForm();
    }

    resetCaptcha () {
        setTimeout(() => {
            let captchasCount = $('.grecaptcha-badge').length;

            for (let i = 0; i < captchasCount; i++) {
                grecaptcha.reset(i);
            }
        }, 500);
    }

    isEmptyForm () {
        let result = false;

        if (this.UI.inputs.username.val() === '') {
            this.UI.messages.empty.removeClass('is-hidden');
            this.UI.inputs.username.addClass('is-invalid');
            result = true;
        }

        if (this.UI.inputs.password.val() === '') {
            this.UI.messages.empty.removeClass('is-hidden');
            this.UI.inputs.password.addClass('is-invalid');
            result = true;
        }

        return result;
    }

    checkIfAllIsFilled () {
        if (this.UI.inputs.username.val() !== '' && this.UI.inputs.password.val() !== '') {
            this.UI.messages.empty.addClass('is-hidden');
        }
    }

    formIsLoading (type = false) {
        if (!type) {
            this.UI.inputs.username.addClass('is-loading');
            this.UI.inputs.password.addClass('is-loading');
            this.UI.inputs.rememberMe.addClass('is-loading');
            this.UI.buttons.submit.addClass('is-loading');
        }

        if (type === 'username') {
            this.UI.inputs.usernameReminder.addClass('is-loading');
            this.UI.buttons.submitUsername.addClass('is-loading');
        }

        if (type === 'password') {
            this.UI.inputs.passwordReminder.addClass('is-loading');
            this.UI.buttons.submitPassword.addClass('is-loading');
        }
    }

    formIsLoaded (type = false) {
        if (!type) {
            this.UI.inputs.username.removeClass('is-loading');
            this.UI.inputs.password.removeClass('is-loading');
            this.UI.inputs.rememberMe.removeClass('is-loading');
            this.UI.buttons.submit.removeClass('is-loading');
            return;
        }

        if (type === 'username') {
            this.UI.inputs.usernameReminder.removeClass('is-loading');
            this.UI.buttons.submitUsername.removeClass('is-loading');
        }

        if (type === 'password') {
            this.UI.inputs.passwordReminder.removeClass('is-loading');
            this.UI.buttons.submitPassword.removeClass('is-loading');
        }
    }

    submitErrorOccurred (response = false, type = false) {
        if (!type) {
            this.UI.messages.submitError.removeClass('is-hidden');
            return;
        }

        if (type === 'username') {
            this.UI.messages.usernameError.removeClass('is-hidden');
            this.UI.messages.usernameError.text(response.responseText);
            return;
        }

        if (type === 'password') {
            this.UI.messages.passwordError.removeClass('is-hidden');
            this.UI.messages.passwordError.text(response.responseText);
            return;
        }
    }

    handleResponse (response, type = false) {
        if (!type) {
            if (!response) {
                this.submitErrorOccurred();
                return;
            }

            if (response.success === 1) {

                // Set Appsflyer event
                if (typeof window.AF !== 'undefined') {
                    AF('pba', 'setCustomerUserId', response.user_id);
                }

                var $_GET = {};

                document.location.search.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function () {
                    function decode(s) {
                        return decodeURIComponent(s.split("+").join(" "));
                    }

                    $_GET[decode(arguments[1])] = decode(arguments[2]);
                });

                window.location.href = !!$_GET['return_url'] ? atob($_GET['return_url']) : window.CSITE.baseUrl;
                return;
            }

            if (response.success > 1 || !response.success) {
                this.UI.messages.error.html(DOMPurify.sanitize(response.message));
                this.UI.messages.error.removeClass('is-hidden');
            }
        }

        if (type === 'username') {
            if (response.success) {
                this.UI.messages.usernameSuccess.removeClass('is-hidden');
            } else {
                this.UI.messages.usernameError.removeClass('is-hidden');

                if (response.message) {
                    this.UI.messages.usernameError.text(response.message);
                } else {
                    this.UI.messages.usernameError.text(response);
                }
            }
        }

        if (type === 'password') {
            if (response.success) {
                this.UI.messages.passwordSuccess.removeClass('is-hidden');
            } else {
                this.UI.messages.passwordError.removeClass('is-hidden');

                if (response.message) {
                    this.UI.messages.passwordError.text(response.message);
                } else {
                    this.UI.messages.passwordError.text(response);
                }
            }
        }
    }

    submitForm () {
        let requestUrl = window.CSITE.baseUrl + 'en/login?option=com_ajax&module=calmradio_login&method=login&format=raw';

        $.ajax({
            url: requestUrl,
            beforeSend: () => {
                this.UI.messages.error.addClass('is-hidden');
                this.UI.messages.success.addClass('is-hidden');
                this.UI.messages.submitError.addClass('is-hidden');
                this.formIsLoading();
            },
            data: this.form.serialize(),
            dataType: 'JSON',
            type: 'POST',
            success: response => {
                this.resetCaptcha();
                this.formIsLoaded();
                this.handleResponse(response);
            },
            error: () => {
                this.resetCaptcha();
                this.formIsLoaded();
                this.submitErrorOccurred();
            }
        });
    }

    submitUsernameForm () {
        let requestUrl = window.CSITE.baseUrl + '?option=com_ajax&module=calmradio_login&method=remind&format=raw';

        $.ajax({
            url: requestUrl,
            beforeSend: () => {
                this.UI.messages.usernameError.addClass('is-hidden');
                this.UI.messages.usernameEmail.addClass('is-hidden');
                this.UI.messages.usernameSuccess.addClass('is-hidden');
                this.formIsLoading('username');
            },
            data: this.UI.forms.username.serialize(),
            dataType: 'JSON',
            type: 'POST',
            success: response => {
                this.resetCaptcha();
                this.formIsLoaded('username');
                this.handleResponse(response, 'username');
            },
            error: response => {
                this.resetCaptcha();
                this.formIsLoaded('username');
                this.submitErrorOccurred(response, 'username');
            }
        });
    }

    submitPasswordForm () {
        let requestUrl = window.CSITE.baseUrl + '?option=com_calmradio&task=user.request&format=json';

        $.ajax({
            url: requestUrl,
            beforeSend: () => {
                this.UI.messages.passwordError.addClass('is-hidden');
                this.UI.messages.passwordEmail.addClass('is-hidden');
                this.UI.messages.passwordSuccess.addClass('is-hidden');
                this.formIsLoading('password');
            },
            data: this.UI.forms.password.serialize(),
            dataType: 'JSON',
            type: 'POST',
            success: response => {
                this.resetCaptcha();
                this.formIsLoaded('password');
                this.handleResponse(response, 'password');
            },
            error: response => {
                this.resetCaptcha();
                this.formIsLoaded('password');
                this.submitErrorOccurred(response, 'password');
            }
        });
    }

    resendEmail () {
        let requestUrl = window.CALMRADIO.baseUrl + '?option=com_calmradio&task=registration.resendRegistrationEmail&format=json';

        $.ajax({
            url: requestUrl,
            beforeSend: () => {
                this.UI.messages.empty.addClass('is-hidden');
                this.UI.messages.error.addClass('is-hidden');
                this.UI.messages.success.addClass('is-hidden');
                this.UI.messages.submitError.addClass('is-hidden');
                this.UI.messages.usernameError.addClass('is-hidden');
                this.UI.messages.usernameEmail.addClass('is-hidden');
                this.UI.messages.usernameSuccess.addClass('is-hidden');
                this.UI.messages.passwordError.addClass('is-hidden');
                this.UI.messages.passwordEmail.addClass('is-hidden');
                this.UI.messages.passwordSuccess.addClass('is-hidden');
                this.formIsLoading();
            },
            data: 'username=' + encodeURIComponent(this.UI.inputs.username.val()),
            dataType: 'JSON',
            type: 'POST',
            success: response => {
                this.formIsLoaded();
                
                if (response && response.success) {
                    this.UI.messages.success.removeClass('is-hidden');
                    this.UI.messages.success.text(response.message);
                } else {
                    this.UI.messages.error.removeClass('is-hidden');
                    this.UI.messages.error.text(response.message);   
                }
            },
            error: response => {
                this.formIsLoaded();
                this.UI.messages.submitError.removeClass('is-hidden'); 
            }
        });
    }

    handleCaptchaError () {
        this.resetCaptcha();
        alert(window.CSITE_LANGS.recaptchaMessage);
    }
}
